/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Form, Spin } from "antd";

import { SelectField } from "../../../../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { useAppDispatch } from "../../../../../../../config/hooks";
import { useEffect, useState } from "react";
import { changeOrAddCrewFromSchedule } from "../../../../../ducks/services";
import { SuccessMessage } from "../../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../../../atoms/Toasts/ErrorMessage";
import {
  getScheduleByDay,
  schedulingFilters,
} from "../../../../../ducks/actions";
import dayjs from "dayjs";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  columnData: any;
  heading: string;
  paragraph?: string | JSX.Element;
  btnText: string;
  loading: boolean;
  secondBtnText?: string;
  isArchivePopup?: boolean;
  crewLeaderId: string;
  crewData?: any;
  selectedDate: Date | null;
  setLoading?: (loading: boolean) => void;
}

type FormValues = {
  clientManager: string;
};

const ChangeCrewLeader = (props: PropsType) => {
  const {
    onClose,
    heading,
    paragraph,
    btnText,
    loading,
    secondBtnText,
    columnData,
    crewLeaderId,
    crewData,
    selectedDate,
    setLoading,
  } = props;
  const dispatch = useAppDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const [crewLeaderList, setCrewLeaderList] = useState<
    { label: string; value: string }[]
  >([]);

  useEffect(() => {
    if (crewData) {
      const crewLeaders = crewData?.map((crew: any) => ({
        label: `${crew?.crewLeader?.first_name ?? ""} ${
          crew?.crewLeader?.last_name ?? ""
        }`,
        value: crew?.crewLeader?.id,
        // icon: crew?.crewLeader?.image_url ? (
        //   <Image
        //     width={24}
        //     src={crew?.crewLeader?.image_url}
        //     preview={false}
        //     style={{ borderRadius: "100px" }}
        //   />
        // ) : (
        //   <Avatar>
        //     {getInitials(
        //       crew?.crewLeader?.first_name ?? "",
        //       crew?.crewLeader?.last_name ?? ""
        //     )}
        //   </Avatar>
        // ),
      }));
      setCrewLeaderList(crewLeaders);
    }
  }, [crewData]);

  const onCloseHandler = () => {
    onClose();
  };

  const onSubmit = (val: FormValues) => {
    setLoading && setLoading(true);
    const payload = {
      user_id: val?.clientManager,
      schedule_id: columnData?.id,
      crew_attendance_id: crewLeaderId,
    };
    changeOrAddCrewFromSchedule(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        dispatch(schedulingFilters());
        SuccessMessage("Crew leader changed");
        setLoading && setLoading(false);
        onCloseHandler();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          ErrorMessage("Something went wrong");
        }
        setLoading && setLoading(false);
      });
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper ">
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_header">
            <div className="title" style={{ marginBottom: "8px" }}>
              <h3> {heading} </h3>
            </div>
          </div>

          <div className="modal_content">
            <p style={{ color: "#151718" }}>{paragraph} </p>
          </div>

          <div className="changeCrewLeaderField" style={{ margin: "20px 0" }}>
            <SelectField
              fieldName="clientManager"
              label="Select crew leader"
              control={control}
              selectOption={crewLeaderList}
              iProps={{
                placeholder: "Select crew leader",
                allowClear: true,
              }}
              isRequired
              rules={{
                required: "Crew leader is required.",
              }}
              validate={errors.clientManager && "error"}
              validMessage={
                errors.clientManager && errors.clientManager.message
              }
            />
          </div>

          <div className="modal_footer">
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              {secondBtnText ? secondBtnText : "Cancel"}
            </Button>

            <Button
              htmlType="submit"
              className="mint-btn"
              type="primary"
              size="large"
              loading={loading}
            >
              {btnText}
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default ChangeCrewLeader;
